import React from 'react';
import { doesAddonExist } from '../../functions';
import { AddonCategoryType, ENUM_ADDON_SELECTION } from 'models/addon-category.model';
import { AddonType } from 'models/addon.model';
import { AddonMealType } from '../../types';
import DetailsCard from 'components/base/cards/details-card';

const MultiSelectionWithQuantityAddon = ({
  filteredAddOn,
  addonSelection,
  onQtyChange
}: {
  filteredAddOn: AddonCategoryType[];
  handleSelectAddon: (addon: AddonType, item: AddonCategoryType) => void;
  onQtyChange: (addon: AddonType, newQty: number, oldQty?: number) => void;
  addonSelection: AddonMealType;
}) => {
  return (
    <div>
      {filteredAddOn[0]?.meal_category_selection_type.name === 'MULTI_SELECTION_WITH_QUANTITY' && (
        <div className=' space-y-6'>
          {filteredAddOn[0].summary && (
            <p className='pb-4 font-medium'>* {filteredAddOn[0].summary}</p>
          )}
          <div className='grid md:grid-cols-2 lg:grid-cols-3 justify-between gap-4 gap-y-6'>
            {(filteredAddOn[0]?.addons as AddonType[]).map((addon, i) => (
              <DetailsCard
                cardType={ENUM_ADDON_SELECTION.MULTI_SELECTION_WITH_QUANTITY}
                active={doesAddonExist(addon.meal_addon_id, addonSelection)}
                title={addon?.meal_data?.name ?? addon?.name}
                key={i}
                price={addon.meal_data.amount}
                quantity={
                  addonSelection[addon.meal_addon_id] &&
                  addonSelection[addon.meal_addon_id]?.quantity
                }
                onQtyChange={(q) =>
                  onQtyChange(addon, q, addonSelection[addon.meal_addon_id]?.quantity)
                }
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiSelectionWithQuantityAddon;
